export default {
  props: {
    application: {
      type: Object,
      default () {
        return {}
      }
    },
    typeList: {
      type: Array
    },
    markList: {
      type: Array
    },
    defaultType: {
      type: String
    },
    defaultMark: {
      type: String
    }
  },
  data () {
    return {
      responseData: {},

      currentType: '',
      currentMark: ''
    }
  },
  watch: {
    responseData (value) {
      this.$emit('sendResponse', value)
    },
    currentType (value) {
      this.$emit('selectType', value)
    },
    currentMark (value) {
      this.$emit('selectMark', value)
      if (value !== '') {
        this.getData([this.currentType, value])
      }
    }
  },
  methods: {
    getData (queryList = []) {
      let query = ''
      if (Array.isArray(queryList) || queryList.length === 0) {
        query = queryList.join('/')
      }
      let vm = this
      this.$http.get('/acat/' + query)
        .then(response => {
          const data = response.data.data
          vm.responseData = data
          if (Array.isArray(data.types)) {
            vm.dataTypeAndMark = data
          }
          if (Array.isArray(data.countries)) {
            vm.dataCountry = data
          }
          if (Array.isArray(data.families)) {
            vm.dataFamily = data
          }
          if (Array.isArray(data.models)) {
            vm.dataModel = data
          }
          if (Array.isArray(data.modifications)) {
            vm.dataModification = data
          }
          if (Array.isArray(data.complectations)) {
            vm.dataComplectations = data
          }
          if (Array.isArray(data.categories)) {
            vm.dataCategory = data
          }
          if (Array.isArray(data.units)) {
            vm.dataUnit = data
          }
          if (Array.isArray(data.groups)) {
            vm.dataGroup = data
          }
          if ((data.unit) && Array.isArray(data.unit.groups)) {
            vm.dataGroup = data.unit
          }
          if (Array.isArray(data.subgroups)) {
            vm.dataSubGroup = data
          }
          if (Array.isArray(data.positions)) {
            this.$emit('updateNumbers', data.positions)
          }
          if (Array.isArray(data.numbers)) {
            this.$emit('updateNumbers', data.numbers)
          }
        })
    },
    getListFromData (dataList, mapFunction) {
      if (!Array.isArray(dataList) || dataList.length === 0) {
        return []
      }
      return dataList.map(mapFunction)
    }
  },
  mounted () {
    this.currentType = this.defaultType
    this.currentMark = this.defaultMark
  }
}



// WEBPACK FOOTER //
// ./src/vue/components/autoCatalogFilter/mixin/filter.js